module.exports = __webpack_public_path__ + "img/45_21.3774da86.png";